import { Component, Inject } from '@angular/core';
import { Question, Choice } from '../../_models/question';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatCheckbox } from '@angular/material/checkbox';
import { DatePipe } from '@angular/common';
import { QuillEditorComponent } from 'ngx-quill';
import { MatButton } from '@angular/material/button';
import { QuillA11yDirective } from '../../_shared/directives/quill-a11y.directive';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';

export interface QuestionData {
  question: Question;
}
@Component({
    selector: 'app-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.css'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, ReactiveFormsModule, FormsModule, MatSelect, MatOption, MatCheckbox, QuillEditorComponent, QuillA11yDirective, MatButton, MatDialogActions, MatDialogClose, DatePipe, MatButtonToggle, MatButtonToggleGroup]
})
export class QuestionComponent {
  editMode = false;
  asc = 1;
  question: Question;
  defaultSets: string[] = [];
  refineValue = '';

  bindings = {
    // This will overwrite the default binding also named 'tab'
    tab: {
      key: 9,
      handler: function () {
        return true;
      }
    }
  };


  modules = {
    clipboard: {
      matchVisual: false
    },
    keyboard: {
      bindings: this.bindings
    },
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons

      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent

      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'align': [] }],

      ['clean'],                                         // remove formatting button

      ['link']                         // link and image, video
    ]
  };

  constructor(
    public dialogRef: MatDialogRef<QuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QuestionData
  ) {
    this.question = this.copyOrDefaultQuestion();
    this.defaultSets = this.computeDefaultSets();
    this.refineValue = this.question.enhanceCalc ? 'refine' : '';
  }

  private copyOrDefaultQuestion(): Question {
    if (this.data?.question) {
      return JSON.parse(JSON.stringify(this.data.question));
    }
    this.editMode = true;
    return {
      section_id: 'SI',

      format: 'Number',
      id: '',
      label: '',
      ordinal: 15000,
      choices: [],
      help: '',

      value: '',

      hidden: false,
      indent: false,
      required: true,

      dependent: true,
      independent: true,

      methodRequired: false,

      flag: false // Used to flag questions changed in annual review
    };
  }

  private computeDefaultSets(): string[] {
    const values: string[] = [];
    if (this.question.imRequired) {
      values.push('im');
    }
    if (this.question.fmRequired) {
      values.push('fm');
    }
    return values;
  }

  onDefaultSetsChange(values: string[]): void {
    this.defaultSets = values ?? [];
    this.question.imRequired = this.defaultSets.includes('im');
    this.question.fmRequired = this.defaultSets.includes('fm');
  }

  onRefineChange(value: string): void {
    this.refineValue = value ?? '';
    this.question.enhanceCalc = this.refineValue === 'refine';
  }

  save(): void {
    // Quill's HTML export encodes every space as &nbsp;, which will not wrap outside the editor.
    if (this.question.help) {
      this.question.help = this.question.help.replace(/&nbsp;/gi, ' ').replace(/\u00A0/g, ' ');
    }
    this.dialogRef.close(this.question);
  }

  deleteQuestion() {
    this.question.dateDeleted = new Date(Date.now());
    this.editMode = false;
  }

  sortChoices(choices: Choice[]) {
    choices.sort((a, b) => (a.value > b.value) ? 1 * this.asc : -1 * this.asc);
    let ord = 1;
    choices.forEach(choice => choice.ord = ord++);
    this.asc *= -1;
  }

  addRow(choices: Choice[]) {
    if (choices.length === 0) {
      this.question.choices = [{
        label: '',
        value: '',
        ord: 1
      }];
    } else {
      const aChoice: Choice = {
        label: '',
        value: '',
        ord: choices[choices.length - 1].ord + 1
      };
      choices.push(aChoice);
    }
  }


  deleteRow(choices: Choice[], index: number) {
    if (choices.length > 1) {
      choices.splice(index, 1);
    } else {
      alert('Cannot delete last row');
    }
  }

}
